import groups from './venueBrandPresentation.json'

// 只匹配已核对的名称；未知场馆保留接口名称，不按排序冒用其它品牌。
export function resolveVenueBrand(group, venue) {
  const normalize=value=>String(value || '').replace(/\s+/g,'').toUpperCase()
  const name=normalize(venue?.name)
  return (groups[group] || []).find(brand=>normalize(brand.name)===name) || null
}
export function venueBrandAsset(path) {
  return path?.startsWith('/reference/') ? `${import.meta.env.BASE_URL}${path.slice(1)}` : ''
}
